// Stable family IDs: soap=1, deodorant=2, extras=3. Display order never changes pricing ownership.
/* Deodorant (cross-family) lines carry `_offer: byob_deodorant`. The
   deodorant-tier-discount Shopify function only discounts deodorants with
   that property (2 sticks 5%, 3 sticks 10%, 4+ sticks 15%). Soap lines never
   carry `_offer`, so the cart drawer keeps rendering the box as a normal
   bundle, not an offer card. */
const BYOB_DEO_OFFER = 'byob_deodorant';
function purchaseLineProperties(opts) {
  const props = { '_bundle-size': opts.bundleSize, '_bundle-id': opts.groupId };
  if (opts.isDeodorant) props['_offer'] = BYOB_DEO_OFFER;
  if (opts.isSubscribe) {
    props['_bundleId'] = opts.txnId || '';
    props['_bundleName'] = opts.bundleName;
  }
  return props;
}
// `skipCross` (soap only) drops the deodorant step: soap → extras → checkout. The
// deodorant PDP keeps its soap cross-sell regardless of the flag.
function purchaseStepOrder(family, skipCross) {
  if (family === 'deodorant') return [2, 1, 3];
  return skipCross ? [1, 3] : [1, 2, 3];
}
// Test hook: set `window.cheekySkipDeoCrossSell = true` (e.g. from an A/B tool)
// before the drawer opens on a soap PDP to hide the "Add Deodorant" step.
function purchaseSkipCrossSell(win) {
  return !!(win && win.cheekySkipDeoCrossSell === true);
}
function nextPurchaseStep(order, current) { return order[order.indexOf(current) + 1] ?? null; }
function reorderPurchaseSteps(stepper, order) {
  if (!stepper) return;
  const separators = Array.from(stepper.querySelectorAll('.mbs-drawer__step-sep'));
  // Any step left out of `order` (e.g. deodorant when cross-sell is skipped)
  // is hidden rather than removed, so a later open can bring it back.
  Array.from(stepper.querySelectorAll('[data-mbs-step-trigger]')).forEach(function (button) {
    const step = parseInt(button.getAttribute('data-mbs-step-trigger'), 10);
    button.hidden = order.indexOf(step) === -1;
  });
  order.forEach(function (step, index) {
    const button = stepper.querySelector('[data-mbs-step-trigger="' + step + '"]');
    if (button) stepper.appendChild(button);
    if (separators[index]) {
      separators[index].hidden = index >= order.length - 1;
      stepper.appendChild(separators[index]);
    }
  });
}
function purchaseAvailability(family, step, soapCount, deoCount, soapMin, deoMin) {
  const first = family === 'deodorant' ? 2 : 1;
  const count = first === 2 ? deoCount : soapCount;
  const min = first === 2 ? deoMin : soapMin;
  const remaining = step === first ? Math.max(0, min - count) : 0;
  return { remaining: remaining, allowed: remaining === 0 && (step !== 3 || soapCount + deoCount > 0) };
}

// Experiments may assign this boolean at any time; only false opts out.
// Watch the value without replacing property descriptors owned by test scripts.
function initializePurchaseSubscriptionDefault(drawer) {
  if (typeof window.cheekyBundleSubscribeByDefault === 'undefined') {
    window.cheekyBundleSubscribeByDefault = true;
  }
  const toggle = drawer.querySelector('[data-mbs-sub-toggle]');
  if (!toggle) return;

  let lastDefault = window.cheekyBundleSubscribeByDefault !== false;
  let applyingDefault = false;
  function applyDefault() {
    applyingDefault = true;
    try {
      toggle.checked = lastDefault;
      toggle.dispatchEvent(new Event('change', { bubbles: true }));
    } finally {
      applyingDefault = false;
    }
  }
  applyDefault();
  const watcher = window.setInterval(function () {
    if (!drawer.isConnected) {
      window.clearInterval(watcher);
      return;
    }
    const nextDefault = window.cheekyBundleSubscribeByDefault !== false;
    if (nextDefault === lastDefault) return;
    lastDefault = nextDefault;
    applyDefault();
  }, 100);
  toggle.addEventListener('change', function () {
    // Default updates must not count as a shopper choosing a purchase type.
    if (!applyingDefault) window.clearInterval(watcher);
  });
}

  /* mbs-drawer — event-delegated interaction script.
     Survives DOM mutations (Shopify section hot-reload, theme editor re-renders) by
     binding ONE click listener on the drawer container and matching targets at fire time. */
  (function init() {
    const drawer = document.getElementById('mbs-drawer');
    if (!drawer) return;
    if (drawer.dataset.mbsBound === '1') return; // idempotent against re-render
    drawer.dataset.mbsBound = '1';
    initializePurchaseSubscriptionDefault(drawer);

    const CROSS_ACTIVE = true;
    function $(sel, root) { return (root || drawer).querySelector(sel); }
    function $$(sel, root) { return Array.from((root || drawer).querySelectorAll(sel)); }
    let stepOrder = [1, 2, 3];
    let currentStep = 1;
    let returnFocus = null;
    let previousOverflow = '';

    function moneyFormat(cents) {
      const n = parseInt(cents, 10) || 0;
      return '$' + (n / 100).toFixed(n % 100 === 0 ? 0 : 2).replace(/\.00$/, '');
    }

    function hideBlockingOverlays() {
      // Any fixed-position iframe or large fixed div with high z-index will steal clicks.
      // Hide them while the drawer is open. Restore them on close.
      const candidates = [];
      document.querySelectorAll('iframe').forEach(function (el) {
        const cs = getComputedStyle(el);
        if (cs.position !== 'fixed') return;
        const r = el.getBoundingClientRect();
        if (r.width < 100 || r.height < 100) return;
        candidates.push(el);
      });
      document.querySelectorAll('body > div, body > section, body > aside').forEach(function (el) {
        if (el === drawer || drawer.contains(el)) return;
        const cs = getComputedStyle(el);
        if (cs.position !== 'fixed') return;
        const r = el.getBoundingClientRect();
        if (r.width < 400 || r.height < 400) return;
        const z = parseInt(cs.zIndex) || 0;
        if (z >= 1000) candidates.push(el);
      });
      candidates.forEach(function (el) {
        if (el.dataset.mbsRestoreDisplay === undefined) {
          el.dataset.mbsRestoreDisplay = el.style.display || '';
          el.style.setProperty('display', 'none', 'important');
        }
      });
    }
    function restoreBlockingOverlays() {
      document.querySelectorAll('[data-mbs-restore-display]').forEach(function (el) {
        const orig = el.dataset.mbsRestoreDisplay;
        if (orig) el.style.display = orig; else el.style.removeProperty('display');
        delete el.dataset.mbsRestoreDisplay;
      });
    }

    function open(opener) {
      returnFocus = opener || document.activeElement;
      const explicitFamily = opener && opener.dataset.purchaseFamily;
      const pageFamily = document.querySelector('[data-purchase-family]');
      const family = explicitFamily || (pageFamily && pageFamily.dataset.purchaseFamily) || drawer.dataset.defaultFamily || 'soap';
      stepOrder = purchaseStepOrder(family, purchaseSkipCrossSell(window));
      drawer.dataset.purchaseFirstFamily = family;
      const stepper = $('[data-mbs-stepper]');
      reorderPurchaseSteps(stepper, stepOrder);
      previousOverflow = document.body.style.overflow;
      hideBlockingOverlays();
      drawer.removeAttribute('hidden');
      drawer.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      setStep(stepOrder[0]);
      const focusTarget = $('[data-mbs-drawer-close]');
      if (focusTarget) focusTarget.focus();
    }
    function close() {
      drawer.setAttribute('hidden', '');
      drawer.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = previousOverflow;
      restoreBlockingOverlays();
      if (returnFocus && returnFocus.isConnected) returnFocus.focus();
    }

    function setStep(n) {
      currentStep = n;
      drawer.classList.toggle('is-step-1', n === 1);
      // `is-step-2` styling (hide the primary progress bar, collapse the image
      // wrapper) applies to every non-primary step. With cross-sell that means
      // both the cross step (2) and the extras step (3). Keeping the class name
      // avoids touching the CSS while covering the new step.
      drawer.classList.toggle('is-step-2', n !== 1);
      // Per-step class for future/targeted styling (motion transitions etc.).
      drawer.setAttribute('data-mbs-current-step', String(n));
      $$('[data-mbs-step-trigger]').forEach(function (t) {
        const on = parseInt(t.getAttribute('data-mbs-step-trigger'), 10) === n;
        t.classList.toggle('is-active', on);
        t.setAttribute('aria-current', on ? 'step' : 'false');
      });
      $$('[data-mbs-step-panel]').forEach(function (p) {
        const on = parseInt(p.getAttribute('data-mbs-step-panel'), 10) === n;
        p.classList.toggle('is-active', on);
        if (on) p.removeAttribute('hidden'); else p.setAttribute('hidden', '');
      });
      const cta = $('[data-mbs-cta]');
      const ctaLabel = $('[data-mbs-cta-label]');
      const next = nextPurchaseStep(stepOrder, n);
      if (cta) { cta.disabled = false; cta.classList.remove('is-disabled'); }
      if (ctaLabel) ctaLabel.textContent = next === null ? (cta.dataset.ctaStep2 || 'Checkout') :
        next === 3 ? 'Next: Extras' : next === 1 ? 'Next: Add Soap' : 'Next: Add Deodorant';
      if (cta && ctaLabel) {
        cta.dataset.currentLabel = ctaLabel.textContent;
        cta.setAttribute('aria-label', ctaLabel.textContent);
      }
      const back = $('[data-mbs-back]');
      if (back) back.hidden = stepOrder.indexOf(n) === 0;
      drawer.dispatchEvent(new CustomEvent('mbs:step-changed'));
    }

    function currentMode() {
      const t = $('[data-mbs-sub-toggle]');
      return t && !t.checked ? 'onetime' : 'sub';
    }

    function applyTierSummary(input) {
      if (!input) return;
      const mode = currentMode();
      const price = mode === 'onetime' ? (input.dataset.priceOnetime || input.dataset.price) : input.dataset.price;
      const compare = mode === 'onetime' ? (input.dataset.compareOnetime || input.dataset.compare) : input.dataset.compare;
      const discount = mode === 'onetime' ? (input.dataset.discountOnetime || input.dataset.discount) : input.dataset.discount;
      const summaryPrice = $('[data-mbs-summary-price]');
      const summaryCompare = $('[data-mbs-summary-compare]');
      const summaryDiscount = $('[data-mbs-summary-discount]');
      if (summaryPrice && price) summaryPrice.textContent = moneyFormat(price);
      if (summaryCompare) {
        const hasCompare = compare && parseInt(compare, 10) > parseInt(price, 10);
        summaryCompare.textContent = hasCompare ? moneyFormat(compare) : '';
      }
      if (summaryDiscount) summaryDiscount.textContent = discount || '';
    }

    function selectQuantity(tier) {
      $$('[data-mbs-qty-tier]').forEach(function (t) { t.classList.toggle('is-selected', t === tier); });
      const input = tier.querySelector('[data-mbs-qty-input]');
      if (input) input.checked = true;
      applyTierSummary(input);
      // Re-render empty slot boxes to match the new bundle size (4/8/12 etc.).
      // refreshBundleUI() calls renderSlots() internally and updates count badges,
      // which is harmless on step 1 since picks is still empty.
      refreshBundleUI();
    }

    // ===== Bundle picker (Step 2) state =====
    // Ordered array of picks — each entry: { handle, label, imageUrl }
    let picks = [];

    // ===== Extras (Step 2 — accessory upsells) state =====
    // (sync nudge)
    // Each entry: { variantId, handle, title, price }. Populated by
    // toggling `[data-mbs-extras-toggle]` buttons on `[data-mbs-extras-card]`
    // tiles in step 2. Submitted alongside `picks` when the CTA fires.
    let extras = [];

    function extrasFindIndex(variantId) {
      for (let i = 0; i < extras.length; i++) {
        if (extras[i].variantId === variantId) return i;
      }
      return -1;
    }

    function extrasToggleCard(card) {
      const variantId = card.getAttribute('data-variant-id');
      if (!variantId) return;
      const idx = extrasFindIndex(variantId);
      if (idx >= 0) {
        // Already added → remove
        extras.splice(idx, 1);
        card.classList.remove('is-added');
      } else {
        // Not added → add
        extras.push({
          variantId: variantId,
          handle: card.getAttribute('data-product-handle') || '',
          title: card.getAttribute('data-product-title') || '',
          price: card.getAttribute('data-product-price') || '',
        });
        card.classList.add('is-added');
      }
      /* Footer total + free-ship meter live in the inline-bundle IIFE (no
         shared scope) — nudge a recompute via event, like mbs:reset. The
         listener reads the selected state off the DOM (.is-added). */
      drawer.dispatchEvent(new CustomEvent('mbs:extras-changed'));
    }

    function requiredBundleSize() {
      const checked = drawer.querySelector('[data-mbs-qty-input]:checked');
      if (!checked) return 1;
      return parseInt(checked.dataset.bundleSize, 10) || 1;
    }

    function countFor(handle) {
      let n = 0;
      for (let i = 0; i < picks.length; i++) if (picks[i].handle === handle) n++;
      return n;
    }

    function renderSlots() {
      const slotsContainer = $('[data-mbs-bundle-slots]');
      if (!slotsContainer) return;
      const required = requiredBundleSize();
      slotsContainer.setAttribute('data-bundle-size', String(required));
      // Clear and rebuild
      slotsContainer.innerHTML = '';
      for (let i = 0; i < required; i++) {
        const slot = document.createElement('div');
        slot.className = 'mbs-drawer__bundle-slot';
        slot.setAttribute('role', 'listitem');
        slot.setAttribute('data-mbs-bundle-slot-index', String(i));
        const pick = picks[i];
        if (pick) {
          slot.classList.add('is-filled');
          slot.setAttribute('data-mbs-bundle-slot-pick', pick.handle);
          slot.setAttribute('title', pick.label || pick.handle);
          slot.setAttribute('aria-label', 'Selected: ' + (pick.label || pick.handle) + ' — click to remove');
          if (pick.imageUrl) {
            const img = document.createElement('img');
            img.src = pick.imageUrl;
            img.alt = pick.label || '';
            img.loading = 'lazy';
            img.decoding = 'async';
            slot.appendChild(img);
          }
        } else {
          slot.setAttribute('aria-label', 'Slot ' + (i + 1) + ' (empty)');
        }
        slotsContainer.appendChild(slot);
      }
    }

    function refreshBundleUI() {
      const required = requiredBundleSize();
      const current = picks.length;
      // Note: the bundle-progress-inline heading ("Pick N scents — current/N") was removed.
      // Progress is now communicated visually by the slot grid (empty boxes for required,
      // filled boxes for current). `required` and `current` are still computed here
      // because the CTA enabled-state logic below uses them.

      // Per-tile count badges
      $$('[data-mbs-flavor-tile]').forEach(function (tile) {
        const handle = tile.getAttribute('data-flavor-handle');
        const c = countFor(handle);
        tile.classList.toggle('is-selected', c > 0);
        const countEl = tile.querySelector('[data-mbs-flavor-count]');
        if (countEl) {
          countEl.textContent = c;
          countEl.toggleAttribute('data-empty', c === 0);
        }
      });

      // Render slot squares
      renderSlots();

      // CTA gating intentionally removed for step 2 (Extras). Previously this
      // disabled the CTA until `picks.length >= requiredBundleSize()`, but
      // step 2 is now the Extras step where the user can checkout at any
      // time. `setStep` is the single source of truth for CTA state.
    }

    function bundleAdd(tile) {
      const required = requiredBundleSize();
      if (picks.length >= required) return;
      const handle = tile.getAttribute('data-flavor-handle');
      if (!handle) return;
      const label = tile.getAttribute('data-flavor-label') || handle;
      const imgEl = tile.querySelector('.mbs-drawer__flavor-thumb img');
      const imageUrl = imgEl ? imgEl.currentSrc || imgEl.src : null;
      picks.push({ handle: handle, label: label, imageUrl: imageUrl });
      refreshBundleUI();
    }

    function bundleRemove(tile) {
      const handle = tile.getAttribute('data-flavor-handle');
      if (!handle) return;
      // Remove the LAST occurrence of this handle from picks
      for (let i = picks.length - 1; i >= 0; i--) {
        if (picks[i].handle === handle) { picks.splice(i, 1); break; }
      }
      refreshBundleUI();
    }

    function bundleRemoveByIndex(idx) {
      if (idx < 0 || idx >= picks.length) return;
      picks.splice(idx, 1);
      refreshBundleUI();
    }

    function resetBundleCounts() {
      picks = [];
      refreshBundleUI();
    }

    function syncSubToggleVisuals() {
      const t = $('[data-mbs-sub-toggle]');
      if (!t) return;
      drawer.classList.toggle('is-onetime', !t.checked);
      // Recompute footer summary against the currently-selected tier
      const checked = drawer.querySelector('[data-mbs-qty-input]:checked');
      if (checked) applyTierSummary(checked);
    }

    // ===== Loop Subscriptions bundle integration =====
    // Ported from snippets/bundle-form-inline.liquid (the canonical bundle form)
    // so the one-step drawer registers a real Loop bundle transaction and writes
    // the grouping + subscription line-item properties the cart/Loop depend on.
    // Config comes from section settings via data-* attributes on #mbs-drawer.
    function loopConfig() {
      return {
        bundleId: drawer.dataset.bundleId || '',
        boxSizeId: drawer.dataset.boxSizeId || '',
        sellingPlanRaw: drawer.dataset.sellingPlanId || '',
        bundleName: drawer.dataset.bundleName || 'Soap Subscription',
      };
    }
    // Preserve a purely-numeric selling plan as a Number (matches canonical);
    // otherwise pass the value through unchanged.
    function sellingPlanValue(raw) {
      return /^\d+$/.test(raw) ? parseInt(raw, 10) : raw;
    }

    // POST a bundle transaction to Loop and resolve to its txnId (or null).
    // Mirrors canonical createLoopTransaction: failures are swallowed so the
    // cart add still proceeds — a null txnId just leaves _bundleId blank.
    function createLoopTransaction(cfg, isSubscribe, barItems) {
      if (!cfg.bundleId) return Promise.resolve(null);
      const productVariants = barItems
        .map(function (it) { return { shopifyId: parseInt(it.id, 10), quantity: it.quantity }; })
        .filter(function (pv) { return !Number.isNaN(pv.shopifyId); });
      const bundleData = {
        boxSizeId: cfg.boxSizeId,
        discountId: null,
        sellingPlanShopifyId: isSubscribe ? sellingPlanValue(cfg.sellingPlanRaw) : null,
        productVariants: productVariants,
        quantity: 1,
      };
      return fetch('https://api.loopsubscriptions.com/storefront/2023-10/bundle/' + cfg.bundleId + '/transaction', {
        method: 'POST',
        headers: { 'accept': 'application/json', 'content-type': 'application/json' },
        body: JSON.stringify(bundleData),
      })
        .then(function (r) {
          if (!r.ok) throw new Error('Loop Create Transaction request failed');
          return r.json();
        })
        .then(function (data) {
          if (data && data.data && data.data.txnId) return data.data.txnId;
          console.warn('[Loop] txnId not present in API response');
          return null;
        })
        .catch(function (err) {
          console.error('[Loop] Unable to create bundle transaction', err);
          return null; // continue with cart add even if Loop fails
        });
    }

    // Full submit flow: Loop transaction FIRST (sub mode only), then
    // /cart/add.js with grouped + subscription line-item properties, then
    // redirect to checkout (both modes).
    function submitBundle() {
      const cta = $('[data-mbs-cta]');
      const ctaLabel = $('[data-mbs-cta-label]');
      const isSubscribe = currentMode() === 'sub';
      const cfg = loopConfig();

      // Collect bar selections from the step-1 product cards. bundleSize = total
      // bars (NOT extras) — drives the _bundle-size grouping property.
      const barItems = [];
      let bundleSize = 0;
      drawer.querySelectorAll('.bundle-product-card-inline').forEach(function (card) {
        const variantId = card.getAttribute('data-variant-id');
        const qtyInput = card.querySelector('.quantity-input-inline');
        const qty = qtyInput ? parseInt(qtyInput.value, 10) || 0 : 0;
        if (variantId && qty > 0) {
          barItems.push({ id: variantId, quantity: qty, isDeodorant: card.getAttribute('data-family') === 'cross' });
          bundleSize += qty;
        }
      });

      // Nothing selected at all — keep the drawer open.
      if (barItems.length === 0 && extras.length === 0) return;

      // Lock the CTA across BOTH network round-trips (prevents double-submit).
      const origLabel = ctaLabel ? ctaLabel.textContent : '';
      if (cta) cta.disabled = true;
      if (ctaLabel) ctaLabel.textContent = 'Adding…';
      if (cta) cta.setAttribute('aria-label', 'Adding…');
      function unlock() {
        if (cta) cta.disabled = false;
        if (ctaLabel) ctaLabel.textContent = origLabel;
        if (cta) cta.setAttribute('aria-label', origLabel);
      }

      // 1) Loop bundle transaction first — subscription mode only (US-003).
      //    One-time boxes never touch Loop: no transaction, and the sub-only
      //    properties (_bundleId/_bundleName/selling_plan) stay off below. The
      //    single txn spans BOTH families — barItems already contains primary
      //    and cross picks, and soap + deodorant share the same Loop bundle id.
      const txnPromise = isSubscribe && barItems.length > 0
        ? createLoopTransaction(cfg, isSubscribe, barItems)
        : Promise.resolve(null);

      txnPromise.then(function (txnId) {
        // 2) Build cart line items. A single shared _bundle-id groups the bars
        //    into one box; subscribe adds the Loop txn link, name, selling plan.
        const groupId = Math.floor(1000 + Math.random() * 9000).toString();
        const items = [];
        barItems.forEach(function (it) {
          const props = purchaseLineProperties({
            bundleSize: bundleSize, groupId: groupId, isDeodorant: it.isDeodorant,
            isSubscribe: isSubscribe, txnId: txnId, bundleName: cfg.bundleName,
          });
          const item = { id: it.id, quantity: it.quantity, properties: props };
          if (isSubscribe) item.selling_plan = sellingPlanValue(cfg.sellingPlanRaw);
          items.push(item);
        });
        // Extras — accessory upsells, always one-time, never bundled.
        extras.forEach(function (x) {
          if (x.variantId) items.push({ id: x.variantId, quantity: 1 });
        });

        if (items.length === 0) { unlock(); return; }

        // Both families and extras share one cart request and checkout.
        const payload = { items: items };
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify(payload),
        })
          .then(function (r) { return r.json().then(function (data) { return { ok: r.ok, status: r.status, data: data }; }); })
          .then(function (result) {
            if (!result.ok) {
              console.error('mbs-drawer: cart add returned', result.status, result.data);
              unlock();
              return;
            }
            window.location.href = '/checkout';
          })
          .catch(function (err) {
            console.error('mbs-drawer: cart add failed', err);
            unlock();
          });
      });
    }

    // ===== SINGLE delegated click handler on the drawer =====
    drawer.addEventListener('click', function (e) {
      if (e.target.closest('[data-mbs-drawer-close]')) { close(); return; }
      if (e.target.closest('[data-mbs-drawer-overlay]') && !e.target.closest('[data-mbs-drawer-panel]')) {
        close(); return;
      }
      const stepBtn = e.target.closest('[data-mbs-step-trigger]');
      if (stepBtn) { setStep(parseInt(stepBtn.getAttribute('data-mbs-step-trigger'), 10)); return; }
      const tier = e.target.closest('[data-mbs-qty-tier]');
      if (tier) {
        const prevTier = drawer.querySelector('.mbs-drawer__qty-tier.is-selected');
        selectQuantity(tier);
        // If user changed tier, the bundle size may have changed — reset selections
        if (prevTier !== tier) resetBundleCounts();
        return;
      }
      // Click on a filled slot square → remove that specific pick by index
      const filledSlot = e.target.closest('.mbs-drawer__bundle-slot.is-filled');
      if (filledSlot) {
        const idx = parseInt(filledSlot.getAttribute('data-mbs-bundle-slot-index'), 10);
        bundleRemoveByIndex(idx);
        return;
      }
      // Quantity selector inside a flavor tile (− N + row).
      // Explicit + and − buttons decide intent; the count span between them
      // is a no-op (just visual). Stop propagation so the tile body's
      // fallback handler doesn't double-fire.
      if (e.target.closest('[data-mbs-flavor-minus]')) {
        const tile = e.target.closest('[data-mbs-flavor-tile]');
        if (tile) bundleRemove(tile);
        e.stopPropagation();
        return;
      }
      if (e.target.closest('[data-mbs-flavor-plus]')) {
        const tile = e.target.closest('[data-mbs-flavor-tile]');
        if (tile) bundleAdd(tile);
        e.stopPropagation();
        return;
      }
      // Clicking the count number itself is a no-op (don't bubble to +1)
      if (e.target.closest('[data-mbs-flavor-count]')) {
        e.stopPropagation();
        return;
      }
      // Tile body click (image, label, anywhere except the qty row) → increment
      const tile = e.target.closest('[data-mbs-flavor-tile]');
      if (tile) { bundleAdd(tile); return; }

      // Extras (Step 2) — toggle an upsell card's "Add to Order" button
      const extrasBtn = e.target.closest('[data-mbs-extras-toggle]');
      if (extrasBtn) {
        const card = extrasBtn.closest('[data-mbs-extras-card]');
        if (card) extrasToggleCard(card);
        e.stopPropagation();
        return;
      }

      // Footer back chevron — one step back (never past step 1).
      if (e.target.closest('[data-mbs-back]')) {
        const index = stepOrder.indexOf(currentStep);
        if (index > 0) setStep(stepOrder[index - 1]);
        return;
      }

      if (e.target.closest('[data-mbs-cta]')) {
        // Advance in the opener-selected family order, then submit from extras.
        const next = nextPurchaseStep(stepOrder, currentStep);
        if (next !== null) { setStep(next); return; }
        // One Loop transaction and cart request, followed by checkout.
        submitBundle();
        return;
      }
    });

    // Sub toggle change — sync class on drawer (CSS handles visual swap via :checked)
    drawer.addEventListener('change', function (e) {
      if (e.target.matches('[data-mbs-sub-toggle]')) syncSubToggleVisuals();
    });

    // Initial state: apply selectQuantity to whatever is checked in the HTML
    const initiallyChecked = drawer.querySelector('[data-mbs-qty-input]:checked');
    if (initiallyChecked) {
      const tier = initiallyChecked.closest('[data-mbs-qty-tier]');
      if (tier) selectQuantity(tier);
    }
    syncSubToggleVisuals();

    // ===== Document-level openers + ESC — guarded against double-bind =====
    if (!document._mbsDrawerGlobalBound) {
      document._mbsDrawerGlobalBound = true;
      document.addEventListener('click', function (e) {
        const opener = e.target.closest('a[href="#mbs-drawer"], [data-mbs-open-drawer]');
        if (opener) {
          e.preventDefault();
          open(opener);
        }
      });
      document.addEventListener('keydown', function (e) {
        if (drawer.hasAttribute('hidden')) return;
        if (e.key === 'Escape') { close(); return; }
        if (e.key !== 'Tab') return;
        const focusable = Array.from(drawer.querySelectorAll('a[href], button, input, select, textarea, [tabindex="0"]')).filter(function (el) {
          return !el.disabled && el.getClientRects().length > 0;
        });
        const first = focusable[0], last = focusable[focusable.length - 1];
        if (!first) { e.preventDefault(); drawer.focus(); return; }
        if (e.shiftKey && (document.activeElement === first || !drawer.contains(document.activeElement))) {
          e.preventDefault(); last.focus();
        } else if (!e.shiftKey && (document.activeElement === last || !drawer.contains(document.activeElement))) {
          e.preventDefault(); first.focus();
        }
      });
    }
  })();


  /* =====================================================================
     INLINE DRAWER — bundle picker interactions (first pass: Add → +/-)
     Mirrors `snippets/bundle-form-inline.liquid`'s addProduct/updateQuantity
     pattern but scoped to the inline drawer's -inline class names.

     What this handles right now:
       1. Click "Add" on a product card → set qty to 1, swap Add → qty stepper
       2. Click + on the stepper → qty++
       3. Click − on the stepper → qty--; if qty hits 0, swap stepper → Add
       4. Progress bar fill + indicator slide + marker activation
          re-render after every change

     What it doesn't do yet:
       - Cart wiring / sessionStorage persistence
       - Subscription vs. one-time pricing math
       - Footer price summary updates
       - Hitting the "Next: Extras" CTA to advance
  ===================================================================== */
  (function initInlineBundle() {
    const drawer = document.getElementById('mbs-drawer');
    if (!drawer) return;
    if (drawer.dataset.mbsInlineBound === '1') return;
    drawer.dataset.mbsInlineBound = '1';

    /* In-memory state: { variantId: quantity } for the PRIMARY family (step 1).
       Footer + progress math iterate this map, so it stays primary-only — the
       cross-sell family (US-001) tracks in a parallel `crossItems` map keyed the
       same way and is NOT folded into the primary total yet (US-002 owns unified
       cross-family pricing). Splitting the maps keeps the legacy primary path
       byte-identical when no cross-sell collection is configured. */
    const items = {};
    const crossItems = {};

    /* A card is cross-family iff Liquid tagged it data-family="cross" (only ever
       emitted inside the cross panel when cross-sell is active). Everything else
       — including all legacy step-1 cards — reads as primary. */
    function cardFamily(card) {
      return card && card.dataset.family === 'cross' ? 'cross' : 'primary';
    }
    function stateFor(family) { return family === 'cross' ? crossItems : items; }

    /* Cross-script reset hook — the submit flow (separate IIFE, no shared
       scope) can dispatch 'mbs:reset' to clear the current selection so the next
       drawer open starts with zeroed quantities. */
    drawer.addEventListener('mbs:reset', function () {
      drawer.querySelectorAll('.bundle-product-card-inline').forEach(function (card) {
        applyCardQuantity(card, 0);
      });
    });

    /* Pricing-engine config, read off the section root's data attributes
       (authored in Liquid from section settings; defaults = original soap
       values, so unconfigured templates behave exactly as before). */
    const UNIT_SINGULAR = drawer.dataset.mbsUnitSingular || 'bar';
    const UNIT_PLURAL = drawer.dataset.mbsUnitPlural || 'bars';
    const SUB_STACKING = drawer.dataset.mbsSubStacking || 'additive';
    const CTA_MIN = parseInt(drawer.dataset.mbsCtaMin, 10) || 4;
    const FREE_SHIP_COUNT = parseInt(drawer.dataset.mbsFreeShipCount, 10) || 0; // 0 = mechanic disabled
    /* Dollar-threshold free shipping (US-002). Present ONLY when the section
       emitted data-mbs-free-ship-dollars (setting non-blank). A non-zero value
       REPLACES the count rule below; blank/0/absent → legacy count behavior. */
    const FREE_SHIP_DOLLARS = parseFloat(drawer.dataset.mbsFreeShipDollars) || 0;

    /* Parse a "count:pct" tier string into an ascending [{count, pct}] list. */
    function parseTierDiscounts(raw, fallback) {
      return (raw || fallback)
        .split(',')
        .map(function (pair) {
          const bits = pair.split(':');
          return { count: parseInt(bits[0], 10), pct: parseFloat(bits[1]) };
        })
        .filter(function (t) { return !isNaN(t.count) && !isNaN(t.pct); })
        .sort(function (a, b) { return a.count - b.count; });
    }

    /* "count:pct" pairs, ascending — e.g. soap "8:5", deodorant "2:5,3:10,4:15" */
    const TIER_DISCOUNTS = parseTierDiscounts(drawer.dataset.mbsTierDiscounts, '8:5');

    /* Cross-family pricing config (US-002). Read off the cross-* data attrs the
       section root emits when cross-sell is active (US-001). Each family is
       priced by its OWN tier curve + OWN sub-stacking mode, counting only its
       own units — mirroring snippets/cart-drawer.liquid's per-family block.
       When cross-sell is inactive these attrs are absent → CROSS_ACTIVE is
       false and the cross branch never runs, so the primary path is untouched. */
    const CROSS_ACTIVE = drawer.dataset.crossActive === 'true';
    const CROSS_TIER_DISCOUNTS = parseTierDiscounts(drawer.dataset.crossTierDiscounts, '2:5,3:10,4:15');
    const CROSS_SUB_STACKING = drawer.dataset.crossSubStacking || 'multiplicative';

    function totalCount() {
      let sum = 0;
      for (const k in items) sum += items[k];
      return sum;
    }
    /* Unit count for a family's state map (cross totals count cross units only). */
    function familyCount(state) {
      let sum = 0;
      for (const k in state) sum += state[k];
      return sum;
    }

    /* Non-linear progress bar mapping, generalized from the soap-specific
       piecewise curve (originally `bundle-form-inline.liquid` lines 2407-2418).
       Markers (from the server-rendered data-count attributes) get an entry
       zone of 100/(2N)% before the first, equal middle zones between markers,
       and a runway after the last sized like the final gap. For soap's 4/8/12
       this reproduces the original values exactly:
         0-4 → 0-16.7%, 4-8 → 16.7-50%, 8-12 → 50-83.3%, 12-16 → 83.3-100%.
       The non-linear curve makes the indicator visibly cross each marker as
       the user picks items, rather than crawling linearly toward the top tier. */
    /* Two progress bars can now coexist (primary + cross, US-007), so every
       bar-level query is scoped to its own container — a drawer-wide query
       would merge the two marker sets and corrupt both curves. */
    const primaryBar = drawer.querySelector('.bundle-progress-inline:not([data-mbs-cross-progress])');
    const crossBar = drawer.querySelector('[data-mbs-cross-progress]');

    function markerCountsIn(bar) {
      if (!bar) return [];
      return Array.prototype.map.call(
        bar.querySelectorAll('.bundle-progress-marker-inline'),
        function (m) { return parseInt(m.dataset.count, 10) || 0; }
      ).sort(function (a, b) { return a - b; });
    }
    const MARKER_COUNTS = markerCountsIn(primaryBar);
    const CROSS_MARKER_COUNTS = markerCountsIn(crossBar);

    function percentForCountIn(markers, count) {
      const n = markers.length;
      if (count <= 0 || n === 0) return 0;
      const edge = 100 / (2 * n);                              // zone before first marker + runway after last
      const mid = n > 1 ? (100 - 2 * edge) / (n - 1) : 100 - 2 * edge; // zones between markers
      const first = markers[0];
      if (count <= first) return (count / first) * edge;
      for (let i = 1; i < n; i++) {
        const prev = markers[i - 1];
        const next = markers[i];
        if (count <= next) {
          return edge + (i - 1) * mid + ((count - prev) / (next - prev)) * mid;
        }
      }
      const last = markers[n - 1];
      const runway = n > 1 ? last - markers[n - 2] : last; // soap: 12→16 over the final 16.7%
      return Math.min(100, edge + (n - 1) * mid + ((count - last) / runway) * edge);
    }
    function percentForCount(count) { return percentForCountIn(MARKER_COUNTS, count); }

    /* Paint one bar's fill, indicator, and marker states from a unit count. */
    function paintProgressBar(bar, markers, count) {
      if (!bar) return;
      const fill = bar.querySelector('.bundle-progress-fill-inline');
      const indicator = bar.querySelector('.bundle-progress-indicator-inline');
      if (!fill || !indicator) return;

      const percent = percentForCountIn(markers, count);
      fill.style.width = percent + '%';
      indicator.textContent = count;
      indicator.style.left = percent + '%';

      /* Light up the tier markers as the user crosses each threshold */
      bar.querySelectorAll('.bundle-progress-marker-inline').forEach(function (m) {
        const threshold = parseInt(m.dataset.count, 10) || 0;
        m.classList.toggle('active', count >= threshold);
      });
    }

    function updateProgressBar() {
      paintProgressBar(primaryBar, MARKER_COUNTS, totalCount());
    }

    /* Cross-family bar (US-007): counts CROSS units only, so on the deo PDP
       the soap bar climbs its own 4/8/12 curve independent of stick picks. */
    function updateCrossProgressBar() {
      paintProgressBar(crossBar, CROSS_MARKER_COUNTS, familyCount(crossItems));
    }

    /* Progress-bar per-bar prices render the subscription price server-side
       (data-sub-price). In one-time mode we strip the 10% subscribe discount
       by dividing each by 0.9, and an applied discount code takes a further 10%
       off (codeDiscountMultiplier) so the per-bar prices match the footer total.
       Tier-independent — only the mode + code matter. */
    function updateProgressPrices() {
      const sub = isSubMode();
      const codeMult = codeDiscountMultiplier();
      /* Per-bar so each family keeps its own unit suffix (/deo vs /bar). */
      const CROSS_UNIT_SINGULAR = drawer.dataset.crossUnitSingular || 'stick';
      [[primaryBar, UNIT_SINGULAR], [crossBar, CROSS_UNIT_SINGULAR]].forEach(function (pair) {
        const bar = pair[0];
        if (!bar) return;
        bar.querySelectorAll('.progress-price-inline').forEach(function (el) {
          const subPrice = parseFloat(el.dataset.subPrice);
          if (isNaN(subPrice)) return;
          const value = (sub ? subPrice : subPrice / 0.9) * codeMult;
          el.textContent = '$' + value.toFixed(2) + '/' + pair[1];
        });
      });
    }

    /* Extras (tray / bags) reflect the 10% code too — it applies to one-time and
       subscription purchases alike, so the discount is independent of the sub toggle.
       Recompute from each card's data-product-price. The server renders the price with
       `money_without_trailing_zeros` (whole dollars → "$11"), so mirror that: whole →
       "$9", otherwise two decimals → "$9.90". */
    function updateExtrasPrices() {
      const codeMult = codeDiscountMultiplier();
      drawer.querySelectorAll('[data-mbs-extras-card]').forEach(function (card) {
        const label = card.querySelector('.mbs-drawer__extras-btn-label');
        if (!label) return;
        const base = parseFloat((card.dataset.productPrice || '').replace(/[^0-9.]/g, ''));
        if (isNaN(base)) return;
        const fmt = function (n) { return n % 1 === 0 ? '$' + n : '$' + n.toFixed(2); };
        if (codeMult < 1) {
          /* Code active: strike the base price beside the discounted one
             ("Add to Order — $11 $9.90"). Numeric-derived strings only, so
             innerHTML is safe here. */
          const price = roundCents(base * codeMult);
          label.innerHTML = 'Add to Order — <s class="mbs-drawer__extras-compare">' + fmt(base) + '</s> ' + fmt(price);
        } else {
          label.textContent = 'Add to Order — ' + fmt(base);
        }
      });
    }

    /* Premium-scent upcharge badge (e.g. "+$.90" on Blue Moon, Zoltraak).
       data-base-premium-cents carries the FULL upcharge over the $7 base. By
       default we show the subscription price (10% off the premium, matching the
       server-rendered value); one-time mode shows the full premium —
       e.g. a $1 premium → "+$.90" (sub) / "+$1" (one-time). */
    function formatPremium(cents) {
      if (cents % 100 === 0) return '+$' + (cents / 100);             // whole dollars → "+$1"
      if (cents < 100) return '+$.' + String(cents).padStart(2, '0'); // sub-dollar → "+$.90"
      return '+$' + (cents / 100).toFixed(2);                         // mixed → "+$1.50"
    }
    function updatePremiumBadges() {
      const sub = isSubMode();
      drawer.querySelectorAll('.limited-edition-badge-inline').forEach(function (el) {
        const full = parseInt(el.dataset.basePremiumCents, 10);
        if (isNaN(full)) return;
        const cents = sub ? Math.floor(full * 9 / 10) : full; // floor matches the Liquid math
        el.textContent = formatPremium(cents);
      });
    }

    function applyCardQuantity(card, qty) {
      const variantId = card.dataset.variantId;
      const family = cardFamily(card);
      const state = stateFor(family);
      if (qty <= 0) {
        delete state[variantId];
      } else {
        state[variantId] = qty;
      }

      const input = card.querySelector('.quantity-input-inline');
      const selector = card.querySelector('.quantity-selector-inline');
      const addBtn = card.querySelector('.add-product-button-inline');

      if (qty > 0) {
        if (input) input.value = qty;
        if (selector) selector.style.display = 'flex';
        if (addBtn) addBtn.style.display = 'none';
        card.dataset.hasQuantity = 'true';
      } else {
        if (input) input.value = 0;
        if (selector) selector.style.display = 'none';
        if (addBtn) addBtn.style.display = ''; /* clears inline 'none', reverts to CSS default */
        delete card.dataset.hasQuantity;
      }

      /* Progress bar + CTA availability track the PRIMARY family only (AC #5):
         the tier badges, progress fill, and "add N more" CTA are keyed to
         primary count. The footer SUMMARY, however, totals BOTH families
         (AC #1), so cross picks must recompute it. When cross-sell is inactive
         no card is ever tagged cross, so this collapses to the legacy path. */
      if (family === 'primary') {
        updateProgressBar();
      } else {
        updateCrossProgressBar();
      }
      updateFooterAvailability();
      updateFooterSummary();
    }

    /* Discount model — two independent layers, both configured per template
       via the engine data attributes (see the section root):
         1. Quantity-tier discount (TIER_DISCOUNTS) — applies in BOTH sub and
            one-time modes. Soap: "8:5" (8+ bars → 5%, 4–7 → none).
            Deodorant: "2:5,3:10,4:15" (an extra 5% per stick, capped at 15%).
         2. Subscribe & save — a flat 10% that applies ONLY in subscription
            mode (toggle on). SUB_STACKING controls how it combines:
              additive       — percentage points sum (soap: 5 + 10 → ×0.85)
              multiplicative — 10% off the tier-discounted price (deodorant:
                               ×0.85 then ×0.9 — matches how a Loop selling-plan
                               adjustment stacks under an automatic discount)
       The whole-box discount is applied per line item (rounded per item) to
       match Shopify's checkout math. */
    function isSubMode() {
      const t = drawer.querySelector('[data-mbs-sub-toggle]');
      return !t || t.checked; // toggle defaults to subscription (checked)
    }
    /* Tier percent for a given count against a specific tier table. The default
       table is the primary family's — cross-family callers pass CROSS_TIER_DISCOUNTS. */
    function tierDiscountPercentFor(count, tiers) {
      const table = tiers || TIER_DISCOUNTS;
      let pct = 0;
      for (let i = 0; i < table.length; i++) {
        if (count >= table[i].count) pct = table[i].pct;
      }
      return pct;
    }
    function tierDiscountPercent(count) {
      return tierDiscountPercentFor(count, TIER_DISCOUNTS);
    }
    function subDiscountPercent() {
      return isSubMode() ? 10 : 0;
    }
    /* Combined tier+subscription multiplier for one line item, parameterized by
       family. `tiers` is that family's tier table, `stacking` its sub-stacking
       mode ('additive' → (100−tier−sub)/100; 'multiplicative' → tier × sub).
       ONE sub toggle governs the whole box, so subDiscountPercent() (which reads
       the single [data-mbs-sub-toggle]) drives BOTH families simultaneously. */
    function tierSubMultiplierFor(count, tiers, stacking) {
      const tierPct = tierDiscountPercentFor(count, tiers);
      const subPct = subDiscountPercent();
      if (stacking === 'multiplicative') {
        return ((100 - tierPct) / 100) * ((100 - subPct) / 100);
      }
      return (100 - tierPct - subPct) / 100;
    }
    /* Primary-family multiplier (legacy signature preserved). */
    function tierSubMultiplier(count) {
      return tierSubMultiplierFor(count, TIER_DISCOUNTS, SUB_STACKING);
    }

    /* Discount-code awareness. A code arriving via a /discount/CODE link sets Shopify's
       `discount_code` cookie; some campaigns also flag `body.discount-applied`. Cheeky's
       storefront discount codes are ALWAYS 10%, so we apply a flat 10% off when one is
       present — the footer preview matches exactly what checkout will charge, computed
       fully client-side before anything is added to the cart. (Shopify still applies the
       real code at checkout regardless of this preview.) */
    function discountCodeFromCookie() {
      const prefix = 'discount_code=';
      const found = document.cookie.split(';').map(function (c) { return c.trim(); })
        .find(function (c) { return c.indexOf(prefix) === 0; });
      return found ? decodeURIComponent(found.slice(prefix.length)) : '';
    }
    function hasDiscountCode() {
      return document.body.classList.contains('discount-applied') || !!discountCodeFromCookie();
    }
    function codeDiscountMultiplier() {
      return hasDiscountCode() ? 0.9 : 1; // storefront codes are always 10% off
    }

    /* Match Shopify's checkout math: apply discount per-line-item, round each
       item's discounted price to the cent, THEN multiply by quantity. Doing
       the multiplication first and rounding at the end would produce
       sub-penny drift that diverges from the cart total. */
    function roundCents(n) { return Math.round(n * 100) / 100; }

    function moneyFmt(n) {
      /* Always show two decimals so '$6' never appears next to '$6.30'.
         '$6.30' looks more committed than '$6.3' too. */
      return '$' + n.toFixed(2);
    }
    function moneyFmtWhole(n) {
      /* Whole-dollar amounts drop the cents ($84, not $84.00) — base prices
         are all whole dollars, so compare-at + savings read cleaner short.
         Non-whole amounts keep two decimals. */
      return Math.abs(n - Math.round(n)) < 1e-9 ? '$' + Math.round(n) : moneyFmt(n);
    }

    /* Footer visibility + CTA enabled state. Two rules:
         1. The entire footer is hidden until count >= 1 (so the empty state
            doesn't dangle a useless "$0.00" + disabled button at the bottom).
         2. Once visible, the CTA stays disabled until count >= CTA_MIN
            (soap: 4 — the first tier discount; deodorant: 1). Below the
            minimum there's nothing to advance to.
       Only enforces on step 1 — step 2 ("Extras") has its own CTA logic. */
    function updateFooterAvailability() {
      const soapCount = totalCount();
      const deoCount = familyCount(crossItems);
      const activeStep = parseInt(drawer.dataset.mbsCurrentStep || '1', 10);
      const family = drawer.dataset.purchaseFirstFamily || 'soap';
      const state = purchaseAvailability(family, activeStep, soapCount, deoCount, CTA_MIN, parseInt(drawer.dataset.deoMinCount || '1', 10));
      const footer = drawer.querySelector('.mbs-drawer__footer');
      if (footer) footer.style.display = '';
      const cta = drawer.querySelector('[data-mbs-cta]');
      const label = drawer.querySelector('[data-mbs-cta-label]');
      if (cta) {
        cta.disabled = !state.allowed;
        cta.classList.toggle('is-disabled', !state.allowed);
        if (label) label.textContent = state.remaining > 0 ? 'Please add ' + state.remaining + ' more ' +
          (family === 'deodorant' ? (state.remaining === 1 ? 'stick' : 'sticks') : (state.remaining === 1 ? 'bar' : 'bars')) :
          (cta.dataset.currentLabel || 'Continue');
        if (label) cta.setAttribute('aria-label', label.textContent);
      }
    }

    /* Accumulate raw + discounted totals for ONE family. Each family is priced
       by its own tier curve (`tiers`) evaluated against its OWN unit count
       (`state` size), and its own sub-stacking mode. Rounding mirrors Shopify
       checkout: tier+subscribe rounds PER ITEM, then × qty; the discount code
       allocates PER LINE (round after × qty). Verified against production carts
       2026-07-06: 2-stick sub + MOIST = 23.94 − round(2.394) = $21.55. */
    function accumulateFamily(state, tiers, stacking, codeMult, acc) {
      const familyUnits = familyCount(state);
      const tierSubMult = tierSubMultiplierFor(familyUnits, tiers, stacking);
      for (const variantId in state) {
        const qty = state[variantId];
        const card = drawer.querySelector('[data-variant-id="' + variantId + '"]');
        const price = card ? (parseFloat(card.dataset.price) || 7) : 7;
        acc.raw += qty * price;
        const lineTierSub = roundCents(price * tierSubMult) * qty;
        acc.discounted += roundCents(lineTierSub * codeMult);
      }
    }

    function updateFooterSummary() {
      /* Footer summary totals BOTH families (US-002); when cross-sell is
         inactive crossItems is empty, so this collapses to the legacy
         primary-only math and renders identically. */
      const count = totalCount() + familyCount(crossItems);
      const compareEl  = drawer.querySelector('.mbs-drawer__footer-compare');
      const priceEl    = drawer.querySelector('.mbs-drawer__footer-price');
      const unitEl     = drawer.querySelector('.mbs-drawer__footer-price-unit');
      const discountEl = drawer.querySelector('.mbs-drawer__footer-discount');

      /* /bar suffix doesn't apply once we're showing total dollars.
         Hide it whenever JS is in charge of the footer values. */
      if (unitEl) unitEl.style.display = 'none';

      if (count === 0) {
        /* Empty cart state: show $0.00, no compare, no discount badge. */
        if (compareEl)  compareEl.textContent = '';
        if (priceEl)    priceEl.textContent = '$0.00';
        if (discountEl) discountEl.textContent = '';
        const freeShipEmpty = drawer.querySelector('[data-mbs-free-shipping]');
        if (freeShipEmpty) freeShipEmpty.hidden = true;
        return;
      }

      const codeMult = codeDiscountMultiplier();

      /* Sum raw (base × qty, no discount) + discounted totals across both
         families. Premium scents carry a higher per-card data-price, so we
         can't shortcut with `count × 7`. */
      const acc = { raw: 0, discounted: 0 };
      accumulateFamily(items, TIER_DISCOUNTS, SUB_STACKING, codeMult, acc);
      if (CROSS_ACTIVE) {
        accumulateFamily(crossItems, CROSS_TIER_DISCOUNTS, CROSS_SUB_STACKING, codeMult, acc);
      }

      /* Extras (tray/bags) ride the same order, so they count toward the
         footer total AND the free-shipping threshold. Full price — no
         tier/sub discounts — but an applied discount code still takes its
         cut (mirrors updateExtrasPrices). Selected state is read off the
         DOM (.is-added) because the extras array lives in the other IIFE. */
      let extrasBase = 0;
      drawer.querySelectorAll('[data-mbs-extras-card].is-added').forEach(function (card) {
        const base = parseFloat((card.dataset.productPrice || '').replace(/[^0-9.]/g, ''));
        if (!isNaN(base)) extrasBase += base;
      });
      acc.raw += extrasBase;
      acc.discounted += extrasBase * codeMult;

      const rawTotal = roundCents(acc.raw);
      const discountedTotal = roundCents(acc.discounted);

      /* Free U.S. shipping. When FREE_SHIP_DOLLARS is set (US-002) it REPLACES
         the count rule: a static "$63 = FREE SHIPPING" pill, always visible
         while the box has items (the running total beside it does the
         counting), flipping green + check (.is-unlocked) once
         discountedTotal >= FREE_SHIP_DOLLARS. Legacy count mode keeps the
         hide-until-unlocked badge (primary units, soap: 12). */
      const freeShipEl = drawer.querySelector('[data-mbs-free-shipping]');
      if (freeShipEl) {
        if (FREE_SHIP_DOLLARS > 0) {
          const unlocked = discountedTotal >= FREE_SHIP_DOLLARS;
          freeShipEl.hidden = false;
          freeShipEl.classList.toggle('is-unlocked', unlocked);
        } else {
          freeShipEl.hidden = !FREE_SHIP_COUNT || totalCount() < FREE_SHIP_COUNT;
        }
      }

      if (discountedTotal < rawTotal) {
        /* Badge shows DOLLAR savings, not % — the effective percentage can
           DROP when the shopper adds items on a shallower discount curve
           (e.g. tiered deo + un-tiered soaps), which reads like a punishment
           for adding more. Dollar savings only ever go up. Derived from the
           totals so tier + subscribe + discount code are all reflected. */
        const saved = roundCents(rawTotal - discountedTotal);
        if (compareEl)  compareEl.textContent = moneyFmtWhole(rawTotal);
        if (priceEl)    priceEl.textContent = moneyFmt(discountedTotal);
        if (discountEl) discountEl.textContent = 'save ' + moneyFmtWhole(saved);
      } else {
        /* No discount active (e.g. 1–3 bars, one-time, no code): full price only. */
        if (compareEl)  compareEl.textContent = '';
        if (priceEl)    priceEl.textContent = moneyFmt(rawTotal);
        if (discountEl) discountEl.textContent = '';
      }

      /* Reflect an applied discount code in the small footer banner. */
      const codeBanner = drawer.querySelector('[data-mbs-discount-banner]');
      if (codeBanner) {
        const code = discountCodeFromCookie();
        if (code) {
          codeBanner.textContent = code.toUpperCase() + ' applied';
          codeBanner.hidden = false;
        } else if (document.body.classList.contains('discount-applied')) {
          codeBanner.textContent = 'Discount applied';
          codeBanner.hidden = false;
        } else {
          codeBanner.hidden = true;
        }
      }
    }

    /* Single delegated click handler, idempotency-guarded above. Routes:
         .add-product-button-inline    → set qty to 1
         .quantity-button-inline.plus  → qty++
         .quantity-button-inline.minus → qty-- (clamped at 0)
       Sold-out cards have disabled add buttons; the early `disabled` check
       skips them silently. */
    drawer.addEventListener('click', function (e) {
      const addBtn = e.target.closest('.add-product-button-inline');
      if (addBtn) {
        if (addBtn.disabled) return;
        const card = addBtn.closest('.bundle-product-card-inline');
        if (card) applyCardQuantity(card, 1);
        return;
      }

      const qtyBtn = e.target.closest('.quantity-button-inline');
      if (qtyBtn) {
        const card = qtyBtn.closest('.bundle-product-card-inline');
        if (!card) return;
        const variantId = card.dataset.variantId;
        /* Read the current qty from the card's own family map so cross-sell
           steppers increment independently of the primary state. */
        const current = stateFor(cardFamily(card))[variantId] || 0;
        const isPlus = qtyBtn.classList.contains('plus');
        applyCardQuantity(card, current + (isPlus ? 1 : -1));
        return;
      }
    });

    /* The base drawer JS resets the CTA's disabled state when switching
       to step 1. We re-apply availability on the NEXT tick (setTimeout 0)
       so the existing setStep handler runs first, then we override. */
    drawer.addEventListener('click', function (e) {
      if (e.target.closest('[data-mbs-step-trigger]')) {
        setTimeout(updateFooterAvailability, 0);
      }
    });

    /* Re-render prices when the subscribe/one-time toggle flips. Both the
       count-based footer summary and the per-bar progress labels depend on the
       mode. The base drawer's own toggle handler only manages the is-onetime
       CSS class, so all mode-dependent price math lives here. */
    drawer.addEventListener('change', function (e) {
      if (e.target.matches('[data-mbs-sub-toggle]')) {
        updateProgressPrices();
        updatePremiumBadges();
        updateFooterSummary();
      }
    });

    /* Extras toggled in the other IIFE — recompute the footer total + the
       free-ship meter (extras count toward both). */
    drawer.addEventListener('mbs:step-changed', updateFooterAvailability);

    drawer.addEventListener('mbs:extras-changed', function () {
      updateFooterSummary();
    });

    /* Paint progress bar, prices, footer summary, AND footer availability at
       count=0 on init so the footer hides + CTA disables before any first
       interaction, and prices match the experiment's initial toggle state. */
    updateProgressBar();
    updateCrossProgressBar();
    updateProgressPrices();
    updatePremiumBadges();
    updateExtrasPrices();
    updateFooterSummary();
    updateFooterAvailability();
  })();
